/**
 * Deep-link legacy: redirige a Catálogo → ficha → tab Receta (ADR-080).
 */
import React, { useEffect } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { useNavigation, useRoute, type RouteProp } from '@react-navigation/native';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors } from '../../shared/theme/ticketColors';
import { OperationalScrollScreen } from '../../shared/ticket/OperationalScrollScreen';
import { ModuleEmptyState } from '../../shared/ui/ModuleEmptyState';
import { useTabWorkspaceLayout } from '../../shared/layout/useContentLayout';
import { useHasBusinessCapability } from '../../shell/session/hooks/useEffectiveBusinessCapabilities';
import { requestCatalogProductDetail } from '../navigation/requestCatalogProductDetail';
import type { RecipeKind } from '../infra/recipesRemoteRepo';

type Params = {
  ProductRecipe: {
    productId: string;
    productName?: string;
    kind?: RecipeKind;
  };
};

export const ProductRecipeScreen = () => {
  const navigation = useNavigation<any>();
  const route = useRoute<RouteProp<Params, 'ProductRecipe'>>();
  const productId = route.params?.productId ?? '';
  const kind: RecipeKind = route.params?.kind === 'disassemble' ? 'disassemble' : 'assemble';
  const hasRecipes = useHasBusinessCapability('recipes');
  const { layoutWide } = useTabWorkspaceLayout();

  useEffect(() => {
    if (!productId || !hasRecipes) return;
    requestCatalogProductDetail(productId, {
      tab: 'receta',
      recipeKind: kind,
      hubSegment: 'products',
    });
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [productId, kind, hasRecipes, navigation]);

  if (!hasRecipes) {
    return (
      <OperationalScrollScreen
        layoutWide={layoutWide}
        contentContainerStyle={styles.content}
        body={
          <ModuleEmptyState
            title="Recetas apagadas"
            subtitle="Prendé Recetas en Funciones del negocio."
          />
        }
      />
    );
  }

  return (
    <OperationalScrollScreen
      layoutWide={layoutWide}
      contentContainerStyle={styles.content}
      body={
        <View style={styles.centered}>
          <ActivityIndicator color={ticketColors.ink} />
        </View>
      }
      testID="catalog.recipe.redirect"
    />
  );
};

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.sm,
    paddingBottom: spacing.xl,
  },
  centered: {
    minHeight: 160,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
